<script setup lang="ts">
import {Textarea} from "@/core/components/ui/textarea";
import {Button} from "@/core/components/ui/button";
import {Send} from "@lucide/vue";

const {maxLength = 1000, disabled = false} = defineProps<{
    maxLength?: number,
    disabled?: boolean
}>();

const emits = defineEmits<{
    (e: 'submit'): void
}>();

const modelValue = defineModel<string>({default: ""});

const handleSubmit = () => {
    if (modelValue.value.trim() && !disabled) {
        emits('submit');
    }
};
</script>

<template>
  <div class="flex gap-2 p-4 border-t bg-white items-start">
    <div class="flex-1">
      <Textarea v-model:model-value="modelValue" class="min-h-12 max-h-32 resize-none" />
      <div v-if="maxLength" class="text-xs text-gray-500 mt-1 text-right">
        {{ modelValue.length }}/{{ maxLength }}
      </div>
    </div>
    <Button :disabled="disabled || !modelValue.trim()" size="sm" class="w-auto bg-primary" @click="handleSubmit">
      <Send class="w-5 h-5" />
    </Button>
  </div>
</template>

<style scoped>

</style>
